
export default [
  {
    "pages": [
      "..."
    ],
    "_meta": {
      "filePath": "buttons/meta.json",
      "fileName": "meta.json",
      "directory": "buttons",
      "extension": "json",
      "path": "buttons/meta"
    }
  },
  {
    "title": "Getting started",
    "pages": [
      "introduction",
      "installation"
    ],
    "_meta": {
      "filePath": "getting-started/meta.json",
      "fileName": "meta.json",
      "directory": "getting-started",
      "extension": "json",
      "path": "getting-started/meta"
    }
  },
  {
    "title": "Base Components",
    "pages": [
      "..."
    ],
    "_meta": {
      "filePath": "kit/meta.json",
      "fileName": "meta.json",
      "directory": "kit",
      "extension": "json",
      "path": "kit/meta"
    }
  },
  {
    "pages": [
      "getting-started",
      "concept",
      "kit",
      "..."
    ],
    "_meta": {
      "filePath": "meta.json",
      "fileName": "meta.json",
      "directory": ".",
      "extension": "json",
      "path": "meta"
    }
  }
]